<div class="form-group row mb-20">
    <div class="col-xs-4 pr-10">
        <label>{{ "widget_product_price" | translate }}</label>
        <input
            type="number"
            placeholder="1"
            class="form-control"
            [formControl]="price"
            [min]="0"
            (blur)="validateInputValue($event.target['value'], price)"
        />
    </div>
    <div class="col-xs-4 pl-10">
        <label>{{ "widget_product_old_price" | translate }}</label>
        <input
            [class.disabled]="!price.value"
            placeholder="1"
            [min]="0"
            class="form-control"
            [formControl]="oldPrice"
            (blur)="validateInputValue($event.target['value'], oldPrice)"
        />
    </div>
</div>
